// extracted by mini-css-extract-plugin
module.exports = {"aff_product_panel_title":"E22ez","aff_product_panel_card":"PMPtz","is_image":"hkS7u","web":"bLF6x"};